export const { REACT_APP_API_URL } = globalThis.window._env_;
